// @need-translate
import {TalkViewerFontFamilyType} from '../../../domain/content/[seriesId]/viewer/[productId]/type/TalkViewerFontFamilyType.enum';
import {ZIndex} from '../../../domain/content/[seriesId]/viewer/[productId]/type/ZIndex.enum';
import {TalkViewerFinishIndicatorProps} from './TalkViewerFinishIndicatorProps.interface';

export function TalkViewerFinishIndicator({
  canShowViewerEnd,
}: TalkViewerFinishIndicatorProps) {
  return (
    <div
      className="absolute inset-x-0 bottom-136tvs mx-auto flex h-80tvs w-430tvs items-center justify-center rounded-6tvs bg-[rgb(var(--colors-static-mono-black)_/_30%)] px-8tvs pb-2tvs text-28tvs font-medium text-static-mono-white"
      style={{
        transform: 'translate3d(0, 0, 0)',
        zIndex: ZIndex.Talk,
      }}
    >
      {canShowViewerEnd
        ? '탭하면 다음편 정보가 노출됩니다.'
        : '탭하면 다음 회차로 넘어갑니다.'}
      <style jsx>
        {`
          div {
            font-family: ${TalkViewerFontFamilyType.Default} !important;
          }
        `}
      </style>
    </div>
  );
}
